import React, { useState, useRef } from 'react';
import './PhotoCapture.css';

function PhotoCapture({ onPhotoCaptured, multiple = true }) {
  const [photos, setPhotos] = useState([]);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const newPhotos = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    }));

    const updatedPhotos = multiple ? [...photos, ...newPhotos] : newPhotos;
    setPhotos(updatedPhotos);
    onPhotoCaptured(updatedPhotos.map((p) => p.file));

    // Reset input so the same file can be selected again
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleRemove = (id) => {
    const photo = photos.find((p) => p.id === id);
    if (photo) {
      URL.revokeObjectURL(photo.preview);
    }
    const updatedPhotos = photos.filter((p) => p.id !== id);
    setPhotos(updatedPhotos);
    onPhotoCaptured(updatedPhotos.map((p) => p.file));
  };

  return (
    <div className="photo-capture">
      <label htmlFor="photo-input" className="photo-capture__label">
        Photos{multiple ? '' : ' (single)'}
      </label>
      <div className="photo-capture__input-wrapper">
        <input
          id="photo-input"
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple={multiple}
          onChange={handleFileChange}
          className="photo-capture__input"
          aria-label="Select photos"
        />
      </div>

      {photos.length > 0 && (
        <div className="photo-capture__previews" aria-label="Photo previews">
          {photos.map((photo) => (
            <div key={photo.id} className="photo-capture__preview">
              <img
                src={photo.preview}
                alt="Preview"
                className="photo-capture__preview-img"
              />
              <button
                type="button"
                className="photo-capture__remove-btn"
                onClick={() => handleRemove(photo.id)}
                aria-label="Remove photo"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default PhotoCapture;
